<template>
  <div>
    <v-row>
      <!-- Exercise column -->

      <v-col cols="12">
        <exercise-logic-multiple
          exCollection="priorityExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          :doc="doc"
          :shared="true"
          :projectShared="false"
          :pid="true"
          :synced="false"
        >
          <template slot-scope="{ saveExercise }">
            <div class="relative">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2
                    class="headline"
                    v-text="$t('exercise_priorites.step1.title')"
                  ></h2>
                </v-col>

                <v-col cols="8" class="">
                  <p
                    v-for="(item, index) in $t(
                      'exercise_priorites.step1.description'
                    )"
                    :key="index"
                    v-text="item"
                  />
                </v-col>
              </v-row>

              <v-row v-if="doc">
                <v-col cols="9" offset="0">
                  <v-row>
                    <v-col cols="6">
                      <v-card light color="light-green accent-2">
                        <v-card-text>
                          <unit-area-items
                            v-model="doc.matrix.q1"
                            name="matrix.q1"
                            title="Quick Wins"
                            subtitle="High impact, Low effort"
                          ></unit-area-items>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card color="orange lighten-1">
                        <v-card-text>
                          <unit-area-items
                            v-model="doc.matrix.q2"
                            name="matrix.q2"
                            title="Priority 2"
                            subtitle="High impact, High effort"
                          ></unit-area-items> </v-card-text
                      ></v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card light color="yellow lighten-1">
                        <v-card-text>
                          <unit-area-items
                            v-model="doc.matrix.q3"
                            name="matrix.q3"
                            title="Priority 1"
                            subtitle="Low impact, Low effort"
                          ></unit-area-items> </v-card-text
                      ></v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card light color="deep-orange lighten-1">
                        <v-card-text>
                          <unit-area-items
                            v-model="doc.matrix.q4"
                            name="matrix.q4"
                            title="Nice to have"
                            subtitle="Low impact, High effort"
                          ></unit-area-items> </v-card-text
                      ></v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <!-- <v-btn
                    v-if="currentUser.uid === '4jd41CisaJZmDYMwCGMRhFclhXY2'"
                    class="amber black--text mb-5 mt-3"
                    text
                    @click="addIdea"
                  >
                    Add Deliverable
                  </v-btn> -->
                  <v-card style="height: 65vh; overflow-y: auto;">
                    <v-card-text>
                      <unit-items
                        v-model="doc.allItems"
                        name="allItems"
                        title="Challenges"
                        :addItem="false"
                        :editItem="false"
                        @edit="editCard"
                      ></unit-items> </v-card-text
                  ></v-card>
                </v-col>
              </v-row>
            </div>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
              @prev="prevStep"
              @next="false"
            >
            </bottom-navigation>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <functionality-add @complete="closeDialog" @close="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <functionality-edit
            :id="cardId"
            :item="cardItem"
            @complete="closeDialog"
            @updateItem="updateItem"
            @close="closeDialog"
          />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == ''">
        <v-card-title
          class="headline"
          v-text="$t('exercise_functionality.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";
// import lodash from 'lodash';

import { UnitAreaItems, UnitItems } from "@/components/units";
const fb = require("@/firebaseConfig.js");

import {
  FunctionalityEdit,
  FunctionalityAdd,
} from "@/views/user/exercises/priority";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserPriority",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      listName: "",
      cardId: null,
      cardItem: {},
      reference: [],
      results: {
        items: [],
      },
      doc: {
        matrix: {
          q1: [],
          q2: [],
          q3: [],
          q4: [],
        },
        list: {},
        listNames: [],
        allItems: [],
        audienceAll: [],
        contentAll: [],
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    UnitItems,
    UnitAreaItems,
    FunctionalityEdit,
    FunctionalityAdd,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    getChallengesEx() {
      let ref = fb.challengesSystemExCollection.where(
        "pid",
        "==",
        this.currentProjectModel.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          console.log("getting challenges");
          result.forEach((doc) => {
            let post = doc.data();
            post.doc.allItems.forEach((x) => {
              const checkArr = [
                ...this.doc.matrix.q1,
                ...this.doc.matrix.q2,
                ...this.doc.matrix.q3,
                ...this.doc.matrix.q4,
              ];
              const checkItem = checkArr.filter((y) => y.id === x.id);
              if (!checkItem.length > 0) {
                items.push({
                  ...x,
                  id: x.id,
                  title: x.name,
                  description: x.challenge,
                });
              }
            });
          });
          this.doc.allItems = items;
        })
        .catch(function() {});
    },
    // getFunctionalityEx() {
    //   let ref = fb.deliverablesExCollection.where(
    //     "pid",
    //     "==",
    //     this.currentProjectModel.id
    //   );
    //   ref
    //     .get()
    //     .then((result) => {
    //       let items = [];
    //       result.forEach((doc) => {
    //         let post = doc.data();
    //         items.push(post);
    //       });
    //       this.flattenArray(items);

    //       // if (refs) {
    //       // 	this.reference = refs;
    //       // }
    //       // if (items) {
    //       // 	const arr = [...this.doc.allItems, ...items];
    //       // 	// const revised = this.doNameCheck(arr);
    //       // 	arr.forEach((x) => {
    //       // 		const item = refs.find((y) => y.id === x.id);
    //       // 		if (item && item.title !== x.title) {
    //       // 			x.title = item.title;
    //       // 		}
    //       // 	});
    //       // 	this.doc.allItems = lodash.orderBy(arr, 'title', 'asc');
    //       // }
    //     })
    //     .catch(function() {});
    // },
    flattenArray(items) {
      const refs = [];
      items.forEach((y) => {
        Object.entries(y?.doc?.categories).forEach(([z, a]) => {
          refs.push({ model: z, values: a });
        });
      });
      console.log("refs", refs);
    },
    checkDuplicates() {
      // let post = doc.data();
      // const testAll = this.doc.allItems.find((x) => x.id === post.id);
      // const test1 = this.doc.matrix.q1.find((x) => x.id === post.id);
      // const test2 = this.doc.matrix.q2.find((x) => x.id === post.id);
      // const test3 = this.doc.matrix.q3.find((x) => x.id === post.id);
      // const test4 = this.doc.matrix.q4.find((x) => x.id === post.id);
      // if (!testAll && !test1 && !test2 && !test3 && !test4) {
      // 	items.push(post);
      // }
      // refs.push(post);
    },
    doNameCheck(arr, refs) {
      arr.forEach((x) => {
        const item = refs.find((y) => y.id === x.id);
        if (item && item.title !== x.title) {
          x.title = item.title;
        }
      });
      return arr;
    },
    onLoadedEx(items) {
      console.log("loaded exercises", items);
      // this.doc = items[0].doc;
      if (items) {
        this.mergeArrays(items[0].doc);
        console.log("loaded exercise");
        this.getChallengesEx();
      } else {
        this.getChallengesEx();
      }
    },
    onModifyEx(items) {
      // console.log("modify exercises", items);
      this.exercises = [...items];
    },
    onSavedNext() {
      this.nextStep();
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editCard($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event.id;
      this.cardItem = $event;
      this.dialog = true;
    },
    updateItem(item) {
      console.log("update item", item);
      const pick = this.doc.allItems.find((x) => x.id === item.id);
      if (pick) {
        const index = this.doc.allItems.indexOf(pick);
        this.$set(this.doc.allItems, index, pick);
      }
    },
    getResults(doc) {
      this.pushToArray(doc.selectedList, "items", "grey lighten-3");
    },
    pushToArray(arr, model, color) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push({
            title: y.title,
            score: y.value,
            description: y.description,
            color: color,
          });
        });
      }
    },
    addList() {
      // let l = Object.keys(this.doc.list).length + 1;
      let lc = this.listName.replace(/\s/g, "").toLowerCase();
      this.doc.listNames.push({ title: this.listName, name: lc });
      this.listName = "";
      this.$set(this.doc.list, lc, []);
    },
    onRemoveList(name) {
      // loop through elements in list and re-distribute to master list
      let items = [];
      Object.values(this.doc.list[name]).forEach((x) => {
        items.push(x);
      });
      this.doc.allItems = [...this.doc.allItems, ...items];
      let item = this.doc.listNames.find((x) => x.name === name);
      let index = this.doc.listNames.indexOf(item);
      this.doc.listNames.splice(index, 1);
      this.$delete(this.doc.list, name);
    },
    onEditList(params) {
      console.log(params);

      let item = this.doc.listNames.find((x) => x.name === params.oldName);
      let index = this.doc.listNames.indexOf(item);
      console.log(index);
      let lc = params.newTitle.replace(/\s/g, "").toLowerCase();
      let renamedItem = {
        title: params.newTitle,
        name: lc,
      };
      this.$set(this.doc.listNames, index, renamedItem);

      let obj = this.doc.list[params.oldName];
      delete this.doc.list[params.oldName];
      this.$set(this.doc.list, lc, obj);
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    renameKey(object, key, newKey) {
      const clonedObj = this.clone(object);
      const targetKey = clonedObj[key];
      delete clonedObj[key];
      clonedObj[newKey] = targetKey;
      return clonedObj;
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      // Object.entries(arr).forEach(([outerKey, value]) => {
      //   Object.entries(value).forEach(([key, value]) => {
      //     this.doc[outerKey][key] = value;
      //   });
      // });
      this.doc = arr;
      // if (arr.length) {
      //   this.doc = arr;
      // }
    },
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    createList() {
      let items = [];
      Object.values(this.doc.matrix).forEach((value) => {
        value.forEach((x) => {
          x.color = "blue lighten-4";
          items.push(x);
        });
      });
      let itemsFromList = [];
      Object.values(this.doc.list).forEach((value) => {
        value.forEach((x) => {
          itemsFromList.push(x);
        });
      });
      let all = [];
      items.forEach((x) => {
        if (!itemsFromList.some((y) => y.title == x.title)) {
          all.push(x);
        }
      });
      this.doc.allItems = all;
    },
  },
};
</script>

<style lang="scss"></style>
